import Vue from 'vue';
import Mapbox from './Components/Mapbox/mapbox.vue';
import Group from './Components/Mapbox/group/group.vue';

/*
 This is the entry point for all maps.

 Any pages containing maps can load this file, and any elements
 of class 'c-mapbox' will be registered as a map container that
 may use our custom Mapbox components
 */

(($) => {
    $(() => {
        // Build the map
        $('.c-mapbox').each((i, el) => {
            const map = new Vue({
                el: el,
                components: {
                    'mapbox': Mapbox,
                    'group': Group
                }
            });
        });
    });
})(jQuery);



// WEBPACK FOOTER //
// ./Assets/Scripts/map.js